import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { Button, Form, Icon, Input, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import moment from 'moment';
import { fetchMarks } from '../../Lookups/util';
import { DateTimePicker } from 'react-widgets';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

class ExternalStudentCourses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: this.props.student,
            userOrganizationalUnitId: this.props.userOrganizationalUnitId,
            courses: [],
            faculties: [],
            studyPrograms: [],
            courseOptions: [],
            organizationalUnitEmployees: [],
            attendanceTypes: [],
            mobilityActivityTypes: [],
            marks: [],
            loading: false,
            error: null,
            editingRowId: null,
            editedRowData: null,
            isAdding: false,
            isDeleting: false,
            deletingRowId: null,
            saving: false,

            errors: {},
        };
    }

    fetchInitialData = async () => {
        this.setState({
            loading: true,
            errorFetchingData: false
        });

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';

        const requests = [
            axios.get(`/external-student-course/external-student/${this.props.externalStudentId}`)
        ];

        if (isStudentService) {
            requests.push(axios.get(`/external-student-organization-unit/external-student/${this.props.externalStudentId}`));
            requests.push(axios.get('/attendance-types'));
            requests.push(axios.get('/study-programs/dto-by-faculty'));
            requests.push(axios.post(`/employees/by-key/professor`, {}));
            requests.push(fetchMarks());
            requests.push(axios.get('/mobility-activity-types'));
        }

        if (isProfessor) {
            requests.push(fetchMarks());
        }

        try {
            const responses = await Promise.all(requests);

            let coursesResponse,
                facultiesResponse = { data: [] },
                attendanceTypesResponse = { data: [] },
                studyProgramsResponse = { data: [] },
                organizationalUnitEmployeesResponse = { data: [] },
                marksResponse = { data: [] },
                mobilityActivityTypesResponse = { data: [] };

            if (isStudentService) {
                [
                    coursesResponse,
                    facultiesResponse,
                    attendanceTypesResponse,
                    studyProgramsResponse,
                    organizationalUnitEmployeesResponse,
                    marksResponse,
                    mobilityActivityTypesResponse
                ] = responses;
            } else if (isProfessor) {
                [
                    coursesResponse,
                    marksResponse
                ] = responses;
            } else {
                [coursesResponse] = responses;
            }

            const faculties = facultiesResponse.data.map(el => ({
                key: el.organizationalUnit.id,
                value: el.id,
                text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
            }));

            let filteredStudyPrograms = studyProgramsResponse.data.filter(sp =>
                sp.studyProgram &&
                sp.studyProgram.name &&
                sp.studyProgram.name.trim() !== '' &&
                sp.studyProgram.studyProgramStatus &&
                sp.studyProgram.studyProgramBasic &&
                sp.studyProgram.studyProgramBasic.name &&
                sp.studyProgram.studyProgramBasic.name.trim() !== '' &&
                (sp.studyProgram.studyProgramStatus.id === 1 || sp.studyProgram.studyProgramStatus.id === 2)
            );

            let studyPrograms = filteredStudyPrograms.map(sp => {
                const studyCycles = (sp.studyCycles && sp.studyCycles.length)
                    ? sp.studyCycles
                    : (sp.studyProgram.studyCycles || []);

                const studyCyclesText = studyCycles.length
                    ? ' | ' + studyCycles.map(sc => sc.name)
                    .join(', ')
                    : '';

                const descriptionText = sp.studyProgram.description
                    ? ' | ' + sp.studyProgram.description
                    : '';

                return {
                    key: sp.studyProgram.id,
                    value: sp.studyProgram.id,
                    text: sp.studyProgram.studyProgramBasic.name.trim() + ' - ' + sp.studyProgram.name.trim()
                        + studyCyclesText
                        + descriptionText,
                    description: sp.studyProgram.studyProgramBasic.comment,
                };
            });

            studyPrograms = [
                {
                    key: 'header',
                    text: <FormattedMessage id="externalStudent.activityTypes"/>,
                    disabled: true
                }, {
                    key: -1,
                    value: -1,
                    text: <FormattedMessage id="externalStudent.otherActivityTypes"/>
                }, {
                    key: 'header',
                    text: <FormattedMessage id="externalStudent.studyPrograms"/>,
                    disabled: true
                },
                ...studyPrograms];

            const attendanceTypes = attendanceTypesResponse.data.map(el => ({
                key: el.id,
                value: el.id,
                text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
            }));

            const marks = marksResponse.data.map(el => ({
                key: el.id,
                value: el.id,
                text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName),
            }));

            const mobilityActivityTypes = mobilityActivityTypesResponse.data.map(el => ({
                key: el.id,
                value: el.id,
                text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
            }));

            const organizationalUnitEmployees = organizationalUnitEmployeesResponse.data.map(emp => ({
                key: emp.organizationalUnitEmployeeId,
                value: emp.organizationalUnitEmployeeId,
                text: `${emp.firstName} ${emp.lastName}`
            }));

            this.setState({
                faculties,
                studyPrograms,
                organizationalUnitEmployees,
                attendanceTypes,
                marks,
                mobilityActivityTypes,
                courses: coursesResponse ? coursesResponse.data : [],
                loading: false
            });
        } catch (err) {
            // console.error('Critical error loading data:', err);
            toast(<FormattedMessage id="externalStudent.toast.errorFetchingData"/>);
            this.setState({
                loading: false,
                errorFetchingData: true
            });
        }
    };

    componentDidMount() {
        this.fetchInitialData();
    }

    fetchCoursesByStudyProgram = (studyProgramId) => {
        const localStorageRole = localStorage.getItem('activeRole') || '';
        if (localStorageRole.slice(0, 10) !== 'Studentska') return;
        if (!studyProgramId) {
            this.setState({ courseOptions: [] });
            return;
        }

        axios.get(`/study-programs/course-study-programs-by-study-program/${studyProgramId}`)
            .then(response => {
                const courseOptions = response.data.map(c => ({
                    ...c,
                    key: c.id,
                    value: c.id,
                    text: c.courseBasicName,
                    description: c.semesterNameKey
                }));

                this.setState({ courseOptions });
            })
            .catch(error => {
                this.setState({ courseOptions: [] });
                toast(<FormattedMessage id="externalStudent.toast.errorFetchingData"/>);
            });
    };

    handleAddClick = () => {
        const newRow = {
            isActivity: false,
        };

        this.setState(prevState => ({
            courses: [newRow, ...prevState.courses],
            editingRowId: newRow.id,
            editedRowData: newRow,
            isAdding: true,
            courseOptions: [],
        }));
        this.resetErrors();
    };

    handleEditClick = (course) => {
        this.setState({
            editingRowId: course.id,
            editedRowData: { ...course },
            isAdding: false
        }, () => {
            // this.handleInputChange('studyProgramId', course.studyProgramId);
            this.fetchCoursesByStudyProgram(course.studyProgramId);
        });
        this.resetErrors();
    };

    handleDeleteClick = (course) => {
        this.setState({
            isDeleting: true,
            deletingRowId: course.id
        });
    };

    handleCancelClick = () => {
        const {
            isAdding,
            editingRowId,
            courses
        } = this.state;

        const newData = isAdding
            ? courses.filter(c => c.id !== editingRowId)
            : courses;

        this.setState({
            courses: newData,
            editingRowId: null,
            editedRowData: null,
            isAdding: false,
            isDeleting: false,
            deletingRowId: null,
        });
    };

    handleSaveClick = () => {
        const {
            courses,
            editedRowData,
            editingRowId,
            isAdding,
            isDeleting,
            deletingRowId
        } = this.state;

        // validation
        if (!isDeleting) {
            const errors = {
                organizationalUnitEmployeeErr: !editedRowData.organizationalUnitEmployeeId,
                attendanceTypeErr: !editedRowData.attendanceTypeId,
                ectsErr: isNaN(Number(editedRowData.ects)) || Number(editedRowData.ects) < 0,
                courseCodeErr: !editedRowData.courseCode || editedRowData.courseCode === '',
                lectureNumberErr: isNaN(Number(editedRowData.lectureNumber)) || Number(editedRowData.lectureNumber) < 0,
                exerciseNumberErr: isNaN(Number(editedRowData.exerciseNumber)) || Number(editedRowData.exerciseNumber) < 0,
                otherNumberErr: isNaN(Number(editedRowData.otherNumber)) || Number(editedRowData.otherNumber) < 0,
                // mobilityActivityTypeErr: editedRowData.isActivity && !editedRowData.mobilityActivityTypeId,
                activityNameErr: editedRowData.isActivity && (!editedRowData.activityName || editedRowData.activityName === ''),
                courseErr: !editedRowData.isActivity && !editedRowData.courseStudyProgramId,
            };
            this.setState({ errors });
            if (Object.values(errors)
                .some(err => err)) {
                toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
                return;
            }
            const sameCourseCount = courses.filter(d => d.courseStudyProgramId === editedRowData.courseStudyProgramId
                && d.id !== editedRowData.id).length;
            if (!editedRowData.isActivity && sameCourseCount !== 0) {
                this.setState({ courseErr: true });
                toast(<FormattedMessage id="externalStudent.toast.duplicateCourse"/>);
                return;
            }
        }

        this.setState({ saving: true });

        let payload = !isDeleting ? {
            isActivity: editedRowData.isActivity,
            externalStudentId: this.props.externalStudentId,
            ects: editedRowData.ects,
            courseCode: editedRowData.courseCode,
            lectureNumber: editedRowData.lectureNumber,
            exerciseNumber: editedRowData.exerciseNumber,
            otherNumber: editedRowData.otherNumber,
            organizationalUnitEmployeeId: editedRowData.organizationalUnitEmployeeId,
            attendanceTypeId: editedRowData.attendanceTypeId,
            dateOfExam: editedRowData.dateOfExam ? new Date(editedRowData.dateOfExam) : null,
            inputDate: new Date(),
        } : {};

        if (!isDeleting && editedRowData.isActivity) {
            payload = {
                ...payload,
                mobilityActivityTypeId: editedRowData.mobilityActivityTypeId,
                activityName: editedRowData.activityName,
            };
        }
        if (!isDeleting && !editedRowData.isActivity) {
            payload = {
                ...payload,
                courseStudyProgramId: editedRowData.courseStudyProgramId,
            };
        }

        let axiosCall = null;
        if (isDeleting) { // delete
            axiosCall = axios.delete(`/external-student-course/${deletingRowId}`);
        } else if (isAdding) { // add
            axiosCall = axios.post('/external-student-course', {
                ...payload,
            });
        } else { // edit
            const localStorageRole = localStorage.getItem('activeRole') || '';
            if (localStorageRole.slice(0, 8) === 'Profesor') { // professor edit
                axiosCall = axios.put(`/external-student-course`, {
                    markId: editedRowData.markId || null,
                    dateOfExam: editedRowData.dateOfExam ? new Date(editedRowData.dateOfExam) : null,
                    id: editingRowId
                });
            } else { // student service edit
                axiosCall = axios.put(`/external-student-course/`, {
                    ...payload,
                    id: editingRowId
                });
            }
        }

        axiosCall
            .then(response => {
                axios.get(`/external-student-course/external-student/${this.props.externalStudentId}`)
                    .then(res => {
                            this.setState({
                                courses: res.data,
                                editingRowId: null,
                                editedRowData: null,
                                isAdding: false,
                                saving: false,
                                isDeleting: false,
                                deletingRowId: null
                            });
                        }
                    );

                if (isAdding) {
                    toast(<FormattedMessage id="externalStudent.toast.courseAdded"/>);
                } else if (isDeleting) {
                    toast(<FormattedMessage id="externalStudent.toast.courseDeleted"/>);
                } else {
                    toast(<FormattedMessage id="externalStudent.toast.courseUpdated"/>);
                }

            })
            .catch(error => {
                if (error.status === 200) return;
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
            });
    };

    handleInputChange = (field, value) => {
        this.setState(prevState => ({
            editedRowData: {
                ...prevState.editedRowData,
                [field]: value
            }
        }), () => {
            if (field === 'studyProgramId') {
                const fun = (isActivity, courseStudyProgramId) => {
                    this.setState(prevState => ({
                        editedRowData: {
                            ...prevState.editedRowData,
                            isActivity,
                            courseStudyProgramId,
                        }
                    }));
                };
                if (value === -1) { // other activity types
                    fun(true, null);
                } else if (value === null || value === '') {
                    fun(false, null);
                } else {
                    fun(false, value);
                }
                this.fetchCoursesByStudyProgram(value);
            }
            if (field === 'courseStudyProgramId') {
                const course = this.getCourseById(value);
                this.setState(prevState => ({
                    editedRowData: {
                        ...prevState.editedRowData,
                        ects: course.ects || 0,
                        courseCode: course.code || '-',
                        lectureNumber: course.lectureNumber || 0,
                        exerciseNumber: course.exerciseNumber || 0,
                        otherNumber: course.otherNumber || 0,
                    }
                }));
            }
        });
    };

    getCourseById = (courseStudyProgramId) => {
        const { courseOptions } = this.state;
        return courseOptions.find(course => course.id === courseStudyProgramId) || {};
    };

    resetErrors = () => {
        this.setState({
            errors: {},
        });
    };

    render() {
        const {
            courses,
            loading,
            editingRowId,
            editedRowData,
            saving,
            isAdding,
            isDeleting,
            deletingRowId,
            errors,
            errorFetchingData,
            userOrganizationalUnitId
        } = this.state;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';

        if (errorFetchingData) {
            return <Segment textAlign={'center'}>
                <Button basic onClick={() => this.fetchInitialData()}>
                    <FormattedMessage id={'externalStudent.loadAgain'}/>
                </Button>
            </Segment>;
        }

        if (loading) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active inline="centered"/></div>;
        }

        return (
            <Form>
                <Fragment>
                    {!loading && (
                        <Table selectable celled compact textAlign={'left'} verticalAlign={'middle'}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>{<FormattedMessage
                                        id="externalStudent.ordinalNumber"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={4}>{<FormattedMessage
                                        id="externalStudent.studyProgramOrActivityType"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={4}>{<FormattedMessage
                                        id="externalStudent.courseOrActivity"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>{<FormattedMessage
                                        id="externalStudent.ects"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={3}>{<FormattedMessage
                                        id="externalStudent.courseCode"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>{<FormattedMessage
                                        id="externalStudent.lectureNumber"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>{<FormattedMessage
                                        id="externalStudent.exerciseNumber"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>{<FormattedMessage
                                        id="externalStudent.otherNumber"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={3}>{<FormattedMessage
                                        id="externalStudent.professor"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={3}>{<FormattedMessage
                                        id="externalStudent.attendanceType"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={3}>{<FormattedMessage
                                        id="externalStudent.examDate"/>}</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>{<FormattedMessage
                                        id="externalStudent.grade"/>}</Table.HeaderCell>
                                    {(isProfessor || isStudentService) && (
                                        <Table.HeaderCell width={2} textAlign="center">
                                            {isStudentService && (
                                                <Popup
                                                    content={<FormattedMessage id="externalStudent.add"/>}
                                                    position="top center"
                                                    trigger={<Button
                                                        basic
                                                        circular
                                                        icon
                                                        size="tiny"
                                                        color="blue"
                                                        onClick={this.handleAddClick}
                                                        disabled={this.state.student.lockedAt || this.state.student.dropoutDate || loading || editingRowId !== null || isAdding || isDeleting}
                                                    >
                                                        <Icon name="plus"/>
                                                    </Button>}/>)}
                                        </Table.HeaderCell>
                                    )}
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {courses.map((course, index) => {
                                    const isEditing = course.id === editingRowId;
                                    const current = isEditing ? editedRowData : course;

                                    return (
                                        <Table.Row key={course.id} verticalAlign={'middle'}>
                                            <Table.Cell verticalAlign={'middle'}>{index + 1}.</Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService && !(course.markId && course.markKey !== 'nonp')) ? (
                                                    <Fragment>
                                                        {/* <FormattedMessage id="externalStudent.otherActivityTypes"> */}
                                                        {/*     {msg => ( */}
                                                        {/*         <Form.Checkbox */}
                                                        {/*             toggle */}
                                                        {/*             label={msg} */}
                                                        {/*             checked={current.isActivity} */}
                                                        {/*             onChange={(e, { checked }) => this.handleInputChange('isActivity', checked)} */}
                                                        {/*         /> */}
                                                        {/*     )} */}
                                                        {/* </FormattedMessage> */}
                                                        <Form.Select
                                                            error={errors.mobilityActivityTypeErr}
                                                            style={{ verticalAlign: 'middle' }}
                                                            fluid
                                                            // options={current.isActivity ? this.state.mobilityActivityTypes : this.state.studyPrograms}
                                                            // value={current.isActivity ? current.mobilityActivityTypeId || null : current.studyProgramId || null}
                                                            options={/*current.isActivity ? this.state.mobilityActivityTypes : */this.state.studyPrograms}
                                                            value={current.isActivity ? -1 : current.studyProgramId || null}
                                                            placeholder={/*current.isActivity ? <FormattedMessage
                                                                    id="externalStudent.selectActivityType"/> :*/
                                                                <FormattedMessage
                                                                    id="externalStudent.selectStudyProgram"/>}
                                                            clearable
                                                            selection
                                                            search
                                                            compact
                                                            onChange={(e, { value }) =>
                                                                /*current.isActivity ? this.handleInputChange('mobilityActivityTypeId', value) : */this.handleInputChange('studyProgramId', value)
                                                            }
                                                        />
                                                    </Fragment>
                                                ) : (
                                                    course.isActivity ? (
                                                        // course.mobilityActivityTypeName
                                                        <FormattedMessage id="externalStudent.otherActivityTypes"/>
                                                    ) : (
                                                        (course.studyProgramBasicName + ' - ' + course.studyProgramName)
                                                    )
                                                )}
                                            </Table.Cell>

                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService && !(course.markId && course.markKey !== 'nonp')) ? (
                                                    current.isActivity ? (
                                                        <Form.Field error={errors.activityNameErr} required>
                                                            <FormattedMessage id="externalStudent.enterActivityName">
                                                                {msg => (
                                                                    <Input
                                                                        fluid
                                                                        placeholder={msg}
                                                                        value={current.activityName || ''}
                                                                        onChange={(e) => this.handleInputChange('activityName', e.target.value)}
                                                                        name="activityName"
                                                                    />
                                                                )}
                                                            </FormattedMessage>
                                                        </Form.Field>
                                                    ) : (
                                                        <Form.Select
                                                            error={errors.courseErr}
                                                            fluid
                                                            options={this.state.courseOptions}
                                                            value={current.courseStudyProgramId || null}
                                                            placeholder={<FormattedMessage
                                                                id="externalStudent.selectCourse"/>}
                                                            clearable
                                                            selection
                                                            search
                                                            compact
                                                            onChange={(e, { value }) => this.handleInputChange('courseStudyProgramId', value)}
                                                        />
                                                    )
                                                ) : (
                                                    course.isActivity ? (
                                                        course.activityName
                                                    ) : (
                                                        course.courseName
                                                    )
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService) ? (
                                                    <Form.Field error={errors.ectsErr} required>
                                                        <FormattedMessage id="externalStudent.enterEcts">
                                                            {msg => (
                                                                <Input
                                                                    fluid
                                                                    type="number"
                                                                    placeholder={msg}
                                                                    value={current.ects}
                                                                    onChange={(e, { value }) => this.handleInputChange('ects', value)}
                                                                    name="ects"
                                                                />
                                                            )}
                                                        </FormattedMessage>
                                                    </Form.Field>
                                                ) : (
                                                    course.ects
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService) ? (
                                                    <Form.Field error={errors.courseCodeErr} required>
                                                        <FormattedMessage id="externalStudent.enterCourseCode">
                                                            {msg => (
                                                                <Input
                                                                    fluid
                                                                    placeholder={msg}
                                                                    value={current.courseCode}
                                                                    onChange={(e, { value }) => this.handleInputChange('courseCode', value)}
                                                                    name="courseCode"
                                                                />
                                                            )}
                                                        </FormattedMessage>
                                                    </Form.Field>
                                                ) : (
                                                    course.courseCode
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService) ? (
                                                    <Form.Field error={errors.lectureNumberErr} required>
                                                        <FormattedMessage id="externalStudent.enterLectureNumber">
                                                            {msg => (
                                                                <Input
                                                                    fluid
                                                                    type="number"
                                                                    placeholder={msg}
                                                                    value={current.lectureNumber}
                                                                    onChange={(e, { value }) => this.handleInputChange('lectureNumber', value)}
                                                                    name="lectureNumber"
                                                                />
                                                            )}
                                                        </FormattedMessage>
                                                    </Form.Field>
                                                ) : (
                                                    course.lectureNumber
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService) ? (
                                                    <Form.Field error={errors.exerciseNumberErr} required>
                                                        <FormattedMessage id="externalStudent.enterExerciseNumber">
                                                            {msg => (
                                                                <Input
                                                                    fluid
                                                                    type="number"
                                                                    placeholder={msg}
                                                                    value={current.exerciseNumber}
                                                                    onChange={(e, { value }) => this.handleInputChange('exerciseNumber', value)}
                                                                    name="exerciseNumber"
                                                                />
                                                            )}
                                                        </FormattedMessage>
                                                    </Form.Field>
                                                ) : (
                                                    course.exerciseNumber
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService) ? (
                                                    <Form.Field error={errors.otherNumberErr} required>
                                                        <FormattedMessage id="externalStudent.enterOtherNumber">
                                                            {msg => (
                                                                <Input
                                                                    fluid
                                                                    type="number"
                                                                    placeholder={msg}
                                                                    value={current.otherNumber}
                                                                    onChange={(e, { value }) => this.handleInputChange('otherNumber', value)}
                                                                    name="otherNumber"
                                                                />
                                                            )}
                                                        </FormattedMessage>
                                                    </Form.Field>
                                                ) : (
                                                    course.otherNumber
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {isEditing && isStudentService && !(course.markId && course.markKey !== 'nonp') ? (
                                                    <Form.Select
                                                        error={errors.organizationalUnitEmployeeErr}
                                                        fluid
                                                        options={this.state.organizationalUnitEmployees}
                                                        value={current.organizationalUnitEmployeeId || null}
                                                        placeholder={<FormattedMessage
                                                            id="externalStudent.selectProfessor"/>}
                                                        clearable
                                                        selection
                                                        search
                                                        compact
                                                        onChange={(e, { value }) => this.handleInputChange('organizationalUnitEmployeeId', value)}
                                                    />
                                                ) : (
                                                    course.employeeName
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isStudentService) ? (
                                                    <Form.Select
                                                        error={errors.attendanceTypeErr}
                                                        fluid
                                                        options={this.state.attendanceTypes}
                                                        value={current.attendanceTypeId || null}
                                                        placeholder={<FormattedMessage
                                                            id="externalStudent.selectAttendanceType"/>}
                                                        clearable
                                                        selection
                                                        search
                                                        compact
                                                        onChange={(e, { value }) => this.handleInputChange('attendanceTypeId', value)}
                                                    />
                                                ) : (
                                                    course.attendanceTypeName
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && (isStudentService || isProfessor)) ? (
                                                    <FormattedMessage id="externalStudent.enterExamDate">
                                                        {msg => (
                                                            <DateTimePicker
                                                                required
                                                                format="D. M. YYYY."
                                                                time={false}
                                                                placeholder={msg}
                                                                value={current.dateOfExam ? new Date(current.dateOfExam) : null}
                                                                onChange={(value) => this.handleInputChange('dateOfExam', value)}
                                                            />
                                                        )}
                                                    </FormattedMessage>
                                                ) : (
                                                    course.dateOfExam
                                                        ? moment(course.dateOfExam)
                                                            .format('D. M. YYYY.')
                                                        : '-'
                                                )}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign={'middle'}>
                                                {(isEditing && isProfessor) ? (
                                                    <Form.Select
                                                        fluid
                                                        options={this.state.marks}
                                                        value={current.markId || null}
                                                        placeholder={<FormattedMessage
                                                            id="externalStudent.selectGrade"/>}
                                                        clearable
                                                        selection
                                                        search
                                                        compact
                                                        onChange={(e, { value }) => this.handleInputChange('markId', value)}
                                                    />
                                                ) : (
                                                    course.markName
                                                )}
                                            </Table.Cell>
                                            {(isProfessor || isStudentService) && (
                                                <Table.Cell textAlign="center" verticalAlign={'middle'}>
                                                    {isEditing || (isDeleting && deletingRowId === course.id) ? (
                                                        <Fragment>
                                                            <Popup
                                                                content={<FormattedMessage id="externalStudent.save"/>}
                                                                position="top center"
                                                                trigger={<Button
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="blue"
                                                                    onClick={this.handleSaveClick}
                                                                    loading={saving && (editingRowId === course.id || isDeleting && deletingRowId === course.id)}
                                                                    disabled={saving}
                                                                >
                                                                    <Icon name="check"/>
                                                                </Button>}/>
                                                            <Popup
                                                                content={<FormattedMessage
                                                                    id="externalStudent.cancel"/>}
                                                                position="top center"
                                                                trigger={<Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="blue"
                                                                    onClick={this.handleCancelClick}
                                                                    disabled={saving}
                                                                >
                                                                    <Icon name="close"/>
                                                                </Button>}/>
                                                        </Fragment>
                                                    ) : !(isStudentService && userOrganizationalUnitId !== course.organizationalUnitId) && (
                                                        <Fragment>
                                                            <Popup
                                                                content={<FormattedMessage
                                                                    id="externalStudent.edit"/>}
                                                                position="top center"
                                                                trigger={<Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="green"
                                                                    disabled={this.state.student.lockedAt || saving || editingRowId && editingRowId !== course.id || isDeleting && deletingRowId !== course.id}
                                                                    onClick={() => this.handleEditClick(course)}
                                                                >
                                                                    <Icon name="pencil"/>
                                                                </Button>}/>
                                                            {isStudentService &&
                                                                (<Popup
                                                                        content={<FormattedMessage
                                                                            id="externalStudent.delete"/>}
                                                                        position="top center"
                                                                        trigger={<Button
                                                                            basic
                                                                            circular
                                                                            icon
                                                                            size="tiny"
                                                                            color="red"
                                                                            disabled={this.state.student.lockedAt || (course.markId && course.markKey !== 'nonp') || saving || (editingRowId && editingRowId !== course.id) || (isDeleting && deletingRowId !== course.id)}
                                                                            onClick={() => this.handleDeleteClick(course)}
                                                                        >
                                                                            <Icon name="trash alternate"/>
                                                                        </Button>}/>
                                                                )}
                                                        </Fragment>
                                                    )}
                                                </Table.Cell>)}
                                        </Table.Row>);
                                })}
                                {courses.length === 0 && (
                                    <Table.Row>
                                        <Table.Cell
                                            textAlign={'left'}
                                            colSpan={(isProfessor || isStudentService) ? 10 : 9}>
                                            {<FormattedMessage id="externalStudent.noGrades"/>}
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                    )}
                </Fragment>
            </Form>
        );
    }
}

export default ExternalStudentCourses;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentProfile/ExternalStudentCourses.js